/* const tabs = document.querySelectorAll('.dynamic-collection__tab-item');
const contents = document.querySelectorAll('.dynamic-collection__tab-content');

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    // Remove active class from all tabs and contents
    tabs.forEach(t => t.classList.remove('active'));
    contents.forEach(c => c.classList.remove('active'));
    
    // Add active class to clicked tab
    tab.classList.add('active');
    
    // Show corresponding content
    const contentId = tab.getAttribute('data-tab');
    document.getElementById(contentId).classList.add('active');
  });
});
*/

class TabSelector extends HTMLElement {
  connectedCallback() {
    this.el = this
    this.tabContainer = this.querySelector('.dynamic-collection__tabs')
    this.tabItems = this.querySelectorAll('.dynamic-collection__tab-item')
    this.tabContents = this.querySelectorAll('.dynamic-collection__tab-content')
    
    this.init()
  }

  init() {
    // Add click listeners to tabs
    this.tabItems.forEach(tab => {
      tab.addEventListener('click', () => this.handleTabClick(tab))
    })
  }

  handleTabClick(clickedTab) {
    // Remove active class from all tabs and contents in this instance
    this.tabItems.forEach(tab => tab.classList.remove('active'))
    this.tabContents.forEach(content => content.classList.remove('active'))
    
    // Add active class to clicked tab
    clickedTab.classList.add('active')
    
    // Show corresponding content
    const contentId = clickedTab.getAttribute('data-tab')
    console.log(`Finding tab content with id ${contentId}`);

     // Find and activate corresponding content with safer approach
      const targetContent = this.querySelector(`#${contentId}`)
      if (targetContent) {
        targetContent.classList.add('active')
      } else {
        console.error(`Content with id "${contentId}" not found in`, this)
      }
  }
}

// Define the custom element
customElements.define('tab-selector', TabSelector)